module.exports = __webpack_public_path__ + "img/cp-01.c390d351.png";